module.exports = __webpack_public_path__ + "img/accessory_hat_06.f124c83a.svg";